import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RichTextEditor } from "./RichTextEditor";
import { CheckCircle2, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import { TemplateVarsHint } from "./TemplateVarsHint";

export const GeneralTemplateCard = ({ api, axiosConfig, onSaved }) => {
  const [text, setText] = useState(null);
  const [def, setDef] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios
      .get(`${api}/settings/general-template`, axiosConfig)
      .then((r) => {
        setText(r.data.template);
        setDef(r.data.default);
      })
      .catch(() => toast.error("Error al cargar la plantilla General"));
    // eslint-disable-next-line
  }, []);

  const save = async (value = text) => {
    setSaving(true);
    try {
      await axios.put(`${api}/settings/general-template`, { template: value }, axiosConfig);
      setText(value);
      toast.success("Plantilla General guardada");
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  if (text === null) return null;

  return (
    <Card className="glass-card border-0 mb-6" data-testid="general-template-card">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <CardTitle className="text-lg font-heading text-sky-900 flex items-center gap-2">
            <FileText className="w-5 h-5" /> Plantilla General
          </CardTitle>
          <button type="button" onClick={() => save(def)} className="text-xs text-sky-600 hover:text-sky-800 hover:underline" data-testid="general-template-reset">
            Restaurar original
          </button>
        </div>
        <CardDescription>Se usa cuando el recordatorio no tiene una plantilla elegida.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <RichTextEditor value={text} onChange={setText} axiosConfig={axiosConfig} previewKind="pre_trip" testId="general-template-editor" />
        <TemplateVarsHint />
        <Button onClick={() => save()} disabled={saving} className="btn-sky text-white" data-testid="general-template-save">
          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
          Guardar plantilla General
        </Button>
      </CardContent>
    </Card>
  );
};
